// extracted by mini-css-extract-plugin
export default {"select":"SelectCell_select__qDZW5"};